import styled, { css } from 'styled-components';
import {
  IError,
  IInputSyle,
  COLOR_ERROR,
  COLOR_BACKGROUND_ERROR,
} from './types';

export const Input = styled.input<IError & IInputSyle>`
  outline: none;
  border: none;
  padding: 15px;
  margin: 0;
  background: #f7f6f9;
  width: ${({ width }) => width ?? '100%'};
  max-width: ${({ maxWidth }) => maxWidth ?? '100%'};
  border-radius: 10px;
  transition: all 0.3s ease-in-out;

  &::placeholder {
    color: #b5b5b5;
  }

  &:focus {
    border: 1.5px solid #005f47;
    background: #f6fffd;
  }
  ${({ error }) => {
    if (error) {
      return css`
        border: 1.5px solid ${COLOR_ERROR};
        background: ${COLOR_BACKGROUND_ERROR};
        color: ${COLOR_ERROR};
        font-weight: 700;

        &::placeholder {
          color: ${COLOR_ERROR}60;
        }
      `;
    }
  }}
`;
